/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Fragment, useState, useEffect, useContext } from 'react';
import ContentEditable from 'react-contenteditable';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import findIndex from 'lodash/findIndex';
import GenericButton from '../../common/GenericButton';
import Modal from '../../common/Modal/Modal';
import backButtonArrow from '../../../images/Autocode/backButtonArrow.svg';

import AutocodeSelectionAction from './AutocodeSelectionActions';
import { useACSelectionBoxContext } from '../ACContext/ACSelectionBoxContext';
import { useACEditContext } from '../ACContext/ACEditContext';
import ACDictionaryContext from '../ACContext/ACDictionaryContext';
import {
  eachNodeTemplate,
  CanCombineSelectedAsNetAny,
  checkAndAddFunctionInAutocodeNode,
} from '../AutocodeFunctions';
import {
  AC_NODETYPE_DEFINITION,
  AC_NODETYPE_OPERATOR,
  AC_NODETYPE_DATAPOINT,
  AC_NODETYPE_FUNC,
  AC_PERSONAL_FOLDER_SCOPE,
  AC_ROOT_NODE_ID,
  AC_OPERATORS,
  MAX_EXPRESSION_LABEL_LIMIT,
} from '../AutocodeConstants';
import { updateSampleWeighted } from '../../../actions/crosstabActions';
// import { GEOGRAPHY_BASES } from '../../../actions/actionTypes';
// import { isNielsenStudyPresent } from '../../../util/CrosstabUtils';
import { FLEX_STUDY_TAG } from '../../../constants';
import { useSelector, useDispatch } from '../../common/react-redux-hooks';
import AutocodeMainSelectionBox from './AutocodeMainSelectionBox';
import { AutocodeSaveDefnSelectionBox } from './AutocodeSaveDefnSelectionBox';
import { AutocodeLabelSelectorDropDown } from './AutocodeLabelSelectorDropDown';
import {
  patchTargetFolder,
  createNewDefinition,
} from '../../../actions/definitionActions';
import { toastError } from '../../../util/toastUtils';
import { _createTargetUniqueID } from '../../../util/deUtils';
import AutocodeSampleWeighted from './AutocodeSampleWeighted';
import AutocodeSampleWeightedDisplay from './AutocodeSampleWeightedDisplay';
import {
  patchEditDefinitions,
  deleteDefinitionExpressions,
  getSampleWeighted,
} from '../../../actions/autocodeActions';
import AC_GRID from '../AutocodeTypes';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../AutocodeLabelsGenerator';
import { DE_BUILD_DUPLICATE_NAME_ERROR } from '../../enablement/shared/DEConstants';
import {
  getDatapointsForSingleList,
  getDatapointsForTemplate1Category,
  getDatapointsForTemplate1BrandTypeKindForm,
  getDatapointsForTemplate4,
  getDatapointsForTemplate278,
} from '../../../util/AutocodeDragAndDropUtils';
import {
  removeAttributesFromACNode,
  getNodeObjectsForDefinitionObjects,
  truncateDefLabel,
} from '../../../util/autocodeUtils';
import { CO1_DEF_EDIT, CO1_DEF_SAVE, COMPOSER_SUBMODULE } from '../../../trackerConstants';

const { toDefString, toLabelString } = AutocodeLabelsGenerator(
  ACStandardLabels,
  null
);

const AutocodeSelectionBox = props => {
  const {
    definitionTab,
    disableAdd,
    moduleStudy,
    uid,
    selectedWeightType,
    ExistingGridData,
    setCheckBlur,
    showDefEditBtn,
    moduleAction,
  } = props;
  const [definition, setdefinition] = useState({
    definitionId: 0,
    folderName: '',
  });
  const {
    editMode,
    editFolderDetails,
    createDefMode,
    seteditMode,
    setbackToDef,
    seteditFolderDetails,
    setcreateDefMode,
    showAddSaveDefinitionBtn,
    showCRBBtns,
    showTargetBtn,
    isSelectionBoxEmptyFlag,
  } = useACEditContext();
  const acSelContext = useACSelectionBoxContext();
  const {
    insertNodes,
    removeAllNodes,
    removeSelectedNodes,
    selectAllNodes,
    splitSelectedOpNodes,
    setOverrideLabelById,
    cancelBulkJoinSetup,
    changeFunctionOfSelectedNodes,
    removeFunctionById,
    removeNetany,
    insertLeafNode,
    insertDefinitionNodes,
    insertOperatorNode,
    insertOperatorNetAnyNode,
    insertNetanyLeafNode,
    setSelectionBoxDefinitionNodes,
    setBackToRootNodeAfterCancel,
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const { selectedNodeAnswers } = useContext(ACDictionaryContext);
  const [saveDefn, setsaveDefn] = useState(false);
  const [editDisabled, seteditDisabled] = useState(true);
  const { loginResponse, sampleWeightedKPIs, activeAccountId } = useSelector(
    state => ({
      loginResponse: state.login.loginResponse,
      sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
      definitionList: state.definition.definitionTree,
      activeAccountId: state.account.activeAccountId,
    })
  );
  // sample weighted counts when only 1 expression in selection box
  // some component is over-rendering and causing multiple requests for this
  // fetching bool is a hack to prevent that
  const [
    singleExpressionSampleWeighted,
    setSingleExpressionSampleWeighted,
  ] = useState({
    fetching: false,
    expression: null, // expression these values are for
    weightName: null,
    response: null,
  });
  const [groupWithOn, setGroupWithOnX] = useState(false);
  const { SampleWeightedCall } = AutocodeSampleWeighted();
  const setGroupWithOn = b => {
    if (b === false) {
      cancelBulkJoinSetup();
    }
    setGroupWithOnX(b);
  };
  const acCodingBoxModal = {
    ref: null,
    styles: {
      width: '700px',
      height: '700px',
      top: '10%',
      left: '30%',
    },
  };

  const dispatch = useDispatch();

  const numTopLevelNodes = () =>
    acSelContext &&
    acSelContext.state &&
    acSelContext.state.rootNode &&
    acSelContext.state.rootNode.children
      ? acSelContext.state.rootNode.children.length
      : 0;

  const selectedNodesCount = () =>
    acSelContext &&
    acSelContext.state &&
    acSelContext.state.rootNode &&
    acSelContext.state.rootNode.children
      ? acSelContext.state.rootNode.children.filter(
          item => item.selected === true
        )
      : [];

  const selectedOperatorCount = () => {
    const filterSelectedOperator =
      acSelContext && acSelContext.state.topLevelOpNodes
        ? acSelContext.state.topLevelOpNodes.filter(
            item => item.data.selected === true
          )
        : [];
    const templateData = eachNodeTemplate(filterSelectedOperator, {
      templateTypeArr: [],
      nodeLabelArr: [],
      timePeriodArr: [],
    });
    const sameTemplate = templateData.templateTypeArr.every(
      (item, index, arr) => item === arr[0]
    );
    const obj =
      filterSelectedOperator.length > 0
        ? {
            label: filterSelectedOperator[0].data.type.label,
            template: sameTemplate
              ? templateData.templateTypeArr[0]
              : undefined,
            count: filterSelectedOperator.length,
            isSameOPSelected: true,
            node: filterSelectedOperator[0],
          }
        : {};
    return obj;
  };

  const checkApplyAllOr = () => {
    let isArrEqual = false;
    const obj = selectedOperatorCount();
    switch (obj.node.type) {
      case AC_NODETYPE_OPERATOR:
      case AC_NODETYPE_DATAPOINT:
        if (
          (obj.node.children[0] && obj.node.children[0].data.rectype === 'a') ||
          (obj.node.children[1] && obj.node.children[1].data.rectype === 'a')
        ) {
          isArrEqual = true;
        }
        break;

      default:
        break;
    }
    return isArrEqual;
  };

  const selectedFuncCount = () => {
    const selectedFuncNode = acSelContext.state.rootNode.children.filter(
      n => n.type === AC_NODETYPE_FUNC && n.data.selected === true
    );

    const templateData = eachNodeTemplate(selectedFuncNode, {
      templateTypeArr: [],
      nodeLabelArr: [],
      timePeriodArr: [],
    });
    const sameTemplate = templateData.templateTypeArr.every(
      (item, index, arr) => item === arr[0]
    );
    return {
      count: selectedFuncNode.length,
      nodeId: selectedFuncNode.length > 0 && selectedFuncNode[0].id,
      node: selectedFuncNode,
      template: sameTemplate ? templateData.templateTypeArr[0] : undefined,
    };
  };

  // will be removed after we have real data
  const showingInDevOnly = () => {
    const local =
      window.location.hostname === 'local.dev.insights.mrisimmons' ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '';
    return process && process.env && process.env.NODE_ENV
      ? process.env.NODE_ENV === 'development' && local
      : false;
  };

  const showingInDevOnlyKeyword = () => {
    const local =
      window.location.hostname === 'local.dev.insights.mrisimmons' ||
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '' ||
      window.location.hostname === 'dev.insights.mrisimmons';
    return local;
  };

  const handleDeleteClicked = () => {
    if (
      acSelContext.editTarget !== null &&
      selectedNodesCount().length > 0 &&
      showTargetBtn
    ) {
      const selectedTargetList = selectedNodesCount();
      const selectedTargetNode = [];
      selectedTargetList.forEach(item => {
        const rowIndex = findIndex(
          acSelContext.state.rootNode.children,
          ele => ele.id === item.id
        );
        selectedTargetNode.push(rowIndex);
      });
      if (selectedTargetNode.indexOf(0) > -1) {
        dispatch(moduleAction.updateErrorSelectionBox(false));
        dispatch(moduleAction.setEditTargetNode(null));
        dispatch(moduleAction.setTempSelectedTargetForBuild(null));
      }
    }
    if (groupWithOn === true) return;

    if (selectedNodesCount().length > 0) removeSelectedNodes();
    else if (selectedOperatorCount().count > 0) splitSelectedOpNodes();
    else if (
      selectedFuncCount().count === 1 &&
      selectedFuncCount().node[0].data.funcName === 'net any' &&
      selectedFuncCount().node[0].children.length > 1
    ) {
      removeNetany(selectedFuncCount().nodeId);
    } else if (selectedFuncCount().count > 0)
      removeFunctionById(selectedFuncCount().nodeId);
    setGroupWithOn(false);
  };

  const tempShowLabels = () => {
    const buildLabelArray = () => {
      const lbls = [];
      _.filter(
        acSelContext.state.rootNode.children,
        n => n.selected
      ).forEach(n =>
        lbls.push(n.toLabelString(acSelContext.state.partsToShow, true))
      );
      return lbls;
    };

    const outstr = _.join(
      buildLabelArray(acSelContext.state.rootNode),
      '\r\n----\r\n'
    );
    /* eslint-disable */
    alert(`labels:  \r\n${outstr}`);
  };

  const tempShowKeywords = () => {
    const buildKeywordArray = () => {
      const lbls = [];
      _.filter(
        acSelContext.state.rootNode.children,
        n => n.selected
      ).forEach(n =>
        lbls.push(n.toExpressionString(acSelContext.state.partsToShow, true))
      );
      return lbls;
    };

    const outstr = _.join(
      buildKeywordArray(acSelContext.state.rootNode),
      '******'
    );
    /* eslint-disable */
    alert(`Keywords: ${outstr}`);
  };

  const tempShowKeywordsInCodingBox = () => {
    const buildKeywordArray = () => {
      const lbls = [];
      _.filter(
        acSelContext.state.rootNode.children,
        n => n.selected
      ).forEach(n =>
        lbls.push(n.toExpressionString(acSelContext.state.partsToShow, true))
      );
      return lbls;
    };

    const outstr = _.join(buildKeywordArray(acSelContext.state.rootNode), '  ');

    const allLabels = [];
    acSelContext.state.rootNode.children.forEach(n =>
      allLabels.push(
        n.toLabelString(
          {
            showCat: false,
            showSCats: false,
            showQ: true,
            showA: true,
          },
          true
        )
      )
    );
    const allKeywords = [];
    acSelContext.state.rootNode.children.forEach(n =>
      allKeywords.push(
        n.toExpressionString(acSelContext.state.partsToShow, true)
      )
    );
    let tableList = '';

    tableList = '<table><thead><th>Labels</th><th>Keywords</th></thead><tbody>';
    allLabels.forEach((n, i) => {
      tableList += `<tr><td>${n}</td><td>${allKeywords[i]}</td></tr>`;
    });
    tableList += '</tbody></table>';

    acCodingBoxModal.ref.show();
    setTimeout(() => {
      document.getElementById('ac-coding-box').innerHTML = outstr;
      document.getElementById('ac-coding-box-table-id').innerHTML = tableList;
    }, 0);
  };

  const tempOverridelabels = (nodeId, newLabel) => {
    _.filter(
      acSelContext.state.rootNode.children,
      n => n.id === nodeId
    ).forEach(n => {
      setOverrideLabelById(n.id, newLabel, true);
    });
  };

  const tempNetAny = () => {
    if (selectedFuncCount().count > 0) {
      changeFunctionOfSelectedNodes('NET ANY', false, true, null);
    } else {
      const testval = CanCombineSelectedAsNetAny(acSelContext.state.rootNode);
      /* eslint-disable */
      console.log({ testval });
    }
  };

  const moveToColumns = () => {
    // makeSampleWeightedCall('ColumnsDataGrid');

    if (acSelContext.state.rootNode.children.length > 0) {
      let extractedContents = acSelContext.state.rootNode.children.filter(
        item => item.selected
      );
      extractedContents =
        extractedContents.length === 0
          ? acSelContext.state.rootNode.children
          : extractedContents;

      SampleWeightedCall(
        'ColumnsDataGrid',
        extractedContents,
        ExistingGridData,
        moduleStudy,
        selectedWeightType,
        activeAccountId,
        uid,
        sampleWeightedKPIs
      );

      if (
        acSelContext.state.rootNode.children.filter(item => item.selected)
          .length > 0
      ) {
        removeSelectedNodes();
      } else {
        removeAllNodes();
      }
    }
  };

  const moveToRows = () => {
    // makeSampleWeightedCall('RowsDataGrid');

    if (acSelContext.state.rootNode.children.length > 0) {
      let extractedContents = acSelContext.state.rootNode.children.filter(
        item => item.selected
      );
      extractedContents =
        extractedContents.length === 0
          ? acSelContext.state.rootNode.children
          : extractedContents;

      SampleWeightedCall(
        'RowsDataGrid',
        extractedContents,
        ExistingGridData,
        moduleStudy,
        selectedWeightType,
        activeAccountId,
        uid,
        sampleWeightedKPIs
      );

      if (
        acSelContext.state.rootNode.children.filter(item => item.selected)
          .length > 0
      ) {
        removeSelectedNodes();
      } else {
        removeAllNodes();
      }
    }
  };

  const moveToBases = () => {
    let isBaseAllowed = false;

    if (!moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG)) {
      isBaseAllowed = true;
    }
    if (isBaseAllowed) {
      // makeSampleWeightedCall('BasesDataGrid');

      if (acSelContext.state.rootNode.children.length > 0) {
        let extractedContents = acSelContext.state.rootNode.children.filter(
          item => item.selected
        );
        extractedContents =
          extractedContents.length === 0
            ? acSelContext.state.rootNode.children
            : extractedContents;

        SampleWeightedCall(
          'BasesDataGrid',
          extractedContents,
          ExistingGridData,
          moduleStudy,
          selectedWeightType,
          activeAccountId,
          uid,
          sampleWeightedKPIs
        );

        if (
          acSelContext.state.rootNode.children.filter(item => item.selected)
            .length > 0
        ) {
          removeSelectedNodes();
        } else {
          removeAllNodes();
        }
      }
    }
  };

  const addToDefinition = () => {
    const expression = [];
    _.forEach(acSelContext.state.rootNode.children, child => {
      const exp = child.toExpressionString();
      const label = child.toLabelString(acSelContext.state.partsToShow, true);
      expression.push({
        id: 0,
        name: truncateDefLabel(label, MAX_EXPRESSION_LABEL_LIMIT),
        expression: exp,
        // save definition object in SPC format
        acnode: removeAttributesFromACNode(child),
      });
    });
    const patchDefinition = {
      token: loginResponse.data.token,
      ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: activeAccountId,
      productNo: moduleStudy.pn,
      newExpressions: expression,
    };
    if (definition.definitionId) {
      patchDefinition.definitionId = definition.definitionId;
      dispatch(patchTargetFolder(patchDefinition)).then(
        result => {
          if (result) {
            setsaveDefn(false);
            disableAdd(false);
            setdefinition({
              definitionId: 0,
              folderName: '',
            });
          }
        },
        error => {
          if (error) {
            toastError(error.message);
          }
        }
      );
    } else {
      patchDefinition.folderName = definition.folderName;
      patchDefinition.thisStudy = false;
      patchDefinition.shared = false;
      dispatch(createNewDefinition(patchDefinition)).then(
        result => {
          if (result) {
            setsaveDefn(false);
            disableAdd(false);
            setdefinition({
              definitionId: 0,
              folderName: '',
            });
          }
        },
        error => {
          if (error) {
            toastError(error.message);
          }
        }
      );
    }
  };

  useEffect(() => {
    if (saveDefn) selectAllNodes(false);
  }, [saveDefn]);

  useEffect(() => {
    if (isSelectionBoxEmptyFlag) {
      const flag = acSelContext.state.rootNode.children.length > 0;
      dispatch(moduleAction.updateSelectionBoxFlag(flag));
    }
    const defItems = acSelContext.state.rootNode.children.every(
      (item, index, arr) => {
        return (
          item.data.breadcrumbs === arr[0].data.breadcrumbs &&
          item.type === AC_NODETYPE_DEFINITION &&
          (item.data.scope === AC_PERSONAL_FOLDER_SCOPE.value1 ||
            item.data.scope === AC_PERSONAL_FOLDER_SCOPE.value2)
        );
      }
    );
    if (numTopLevelNodes() > 0 && defItems) {
      seteditDisabled(false);
    } else {
      seteditDisabled(true);
    }
  }, [acSelContext.state.rootNode.children]);

  useEffect(() => {
    // show sample/weighted counts if 1 item in selection box
    // and not a flex market study
    if (
      numTopLevelNodes() === 1 &&
      !moduleStudy.st.toLowerCase().includes(FLEX_STUDY_TAG) &&
      !singleExpressionSampleWeighted.fetching
    ) {
      const expressionList = acSelContext.state.rootNode.children.map(c =>
        c.toExpressionString(acSelContext.state.partsToShow, true)
      );
      // only fetch values if expression or weight type are different
      if (
        expressionList[0] !== singleExpressionSampleWeighted.expression ||
        selectedWeightType.wn !== singleExpressionSampleWeighted.weightName
      ) {
        setSingleExpressionSampleWeighted({
          ...singleExpressionSampleWeighted,
          fetching: true,
        });
        getSampleWeighted(
          uid,
          activeAccountId,
          moduleStudy.pn,
          selectedWeightType.wt,
          selectedWeightType.dv,
          expressionList
        ).then(response => {
          setSingleExpressionSampleWeighted({
            fetching: false,
            response,
            expression: expressionList[0],
            weightName: selectedWeightType.wn,
          });
        });
      }
    } else {
      setSingleExpressionSampleWeighted({
        ...singleExpressionSampleWeighted,
        response: null,
        expression: null,
        weightName: null,
      });
    }
  }, [acSelContext.state.rootNode.children, selectedWeightType]);

  useEffect(() => {
    if (
      acSelContext.state.rootNode.children[0] &&
      acSelContext.tempTarget !== null &&
      showTargetBtn
    ) {
      const target = {};
      const uniqueId = _createTargetUniqueID(
        acSelContext.state.rootNode.children[0],
        acSelContext.state.partsToShow,
        moduleStudy.pn,
        selectedWeightType.wn
      );
      target.ui = uniqueId;
      target.tn = toLabelString(
        acSelContext.state.rootNode.children[0],
        acSelContext.state.partsToShow
      );
      target.ex = toDefString(
        acSelContext.state.rootNode.children[0],
        acSelContext.state.partsToShow
      );
      target.sn = `${moduleStudy.sd} ${selectedWeightType.wn}`;
      target.wt = selectedWeightType.wt;
      target.pn = moduleStudy.pn;
      dispatch(moduleAction.setEditTargetNode(target));
    }
  }, [
    moduleStudy,
    selectedWeightType,
    acSelContext.state.rootNode.children[0],
  ]);

  useEffect(() => {
    if (showTargetBtn) {
      dispatch(moduleAction.updateErrorSelectionBox(false));
    }
  }, [
    definition,
    saveDefn,
    editDisabled,
    singleExpressionSampleWeighted,
    groupWithOn,
    acSelContext.state.rootNode.children,
  ]);

  const handleEditClick = async () => {
    seteditFolderDetails([
      ...acSelContext.state.rootNode.children.map(item => item.data),
    ]);
    acSelContext.state.setTabsIndex(0);
    seteditMode(true);

    setbackToDef(false);

    // User tracking for edit definition
    acSelContext.trackerFn({ action: CO1_DEF_EDIT, subModule: COMPOSER_SUBMODULE });

    // Definition objects in SB
    const definitions = acSelContext.state.rootNode.children.map(
      item => item.data
    );

    // Get node objects
    const nodes = await getNodeObjectsForDefinitionObjects(
      definitions,
      uid,
      activeAccountId,
      moduleStudy.pn
    );
    setSelectionBoxDefinitionNodes(acSelContext.state.rootNode);

    // Clear SB and nodes
    removeAllNodes();
    insertNodes(nodes, '0', -1);
  };

  const patchEditCreateDefs = () => {
    acSelContext.trackerFn({ action: CO1_DEF_SAVE, subModule: COMPOSER_SUBMODULE });
    if (editMode) {
      const expressionList = [];
      if (editFolderDetails.length === 1) {
        const expName =
          acSelContext.state.rootNode.children[0].labelOverride.trim() !== ''
            ? acSelContext.state.rootNode.children[0].labelOverride
            : editFolderDetails[0].title;

        expressionList.push({
          id: editFolderDetails[0].expressionId,
          name: truncateDefLabel(expName, MAX_EXPRESSION_LABEL_LIMIT),
          expression: acSelContext.state.rootNode.children[0].toExpressionString(
            acSelContext.state.partsToShow,
            true
          ),
          // save definition object in SPC format
          acnode: removeAttributesFromACNode(
            acSelContext.state.rootNode.children[0]
          ),
        });

        patchEditDefinitions(
          activeAccountId,
          moduleStudy.ss === 'SIMMONS' ? 1 : 2,
          editFolderDetails[0].selectedFolder.definitionId,
          expressionList
        ).then(response => {
          if (response === 200) {
            seteditMode(false);
            setcreateDefMode(false);
            setbackToDef(true);
          }
        });
      } else {
        expressionList.push(
          ...editFolderDetails.map(item => item.expressionId)
        );

        const expression = [];
        _.forEach(acSelContext.state.rootNode.children, child => {
          const exp = child.toExpressionString();
          const label = child.toLabelString(acSelContext.state.partsToShow, true);
          expression.push({
            id: 0,
            name: truncateDefLabel(label, MAX_EXPRESSION_LABEL_LIMIT),
            expression: exp,
            // save definition object in SPC format
            acnode: removeAttributesFromACNode(child),
          });
        });
        const patchDefinition = {
          token: loginResponse.data.token,
          ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
          accountId: activeAccountId,
          productNo: moduleStudy.pn,
          newExpressions: expression,
        };
        patchDefinition.definitionId =
          editFolderDetails[0].selectedFolder.definitionId;
        dispatch(patchTargetFolder(patchDefinition)).then(
          result => {
            if (result) {
              deleteDefinitionExpressions(
                activeAccountId,
                moduleStudy.ss === 'SIMMONS' ? 1 : 2,
                editFolderDetails[0].selectedFolder.definitionId,
                expressionList
              ).then(response => {
                if (response === 200) {
                  seteditMode(false);
                  setcreateDefMode(false);
                  setbackToDef(true);
                }
              });
            }
          },
          error => {
            if (error) {
              toastError(error.message);
            }
          }
        );
      }
    } else if (createDefMode) {
      const expression = [];
      _.forEach(acSelContext.state.rootNode.children, child => {
        const exp = child.toExpressionString();
        const label = child.toLabelString(acSelContext.state.partsToShow, true);
        expression.push({
          id: 0,
          name: truncateDefLabel(label, MAX_EXPRESSION_LABEL_LIMIT),
          expression: exp,
          // save definition object in SPC format
          acnode: removeAttributesFromACNode(child),
        });
      });
      const patchDefinition = {
        token: loginResponse.data.token,
        ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
        accountId: activeAccountId,
        productNo: moduleStudy.pn,
        newExpressions: expression,
      };
      patchDefinition.definitionId =
        editFolderDetails[0].selectedFolder.definitionId;
      dispatch(patchTargetFolder(patchDefinition)).then(
        result => {
          if (result) {
            acSelContext.state.setTabsIndex(1);
            seteditMode(false);
            setcreateDefMode(false);
            setbackToDef(true);
          }
        },
        error => {
          if (error) {
            toastError(error.message);
          }
        }
      );
    }
    removeAllNodes();
  };

  const editCreateDefCancel = () => {
    acSelContext.state.setTabsIndex(1);
    seteditMode(false);
    setcreateDefMode(false);
    setbackToDef(true);
    setBackToRootNodeAfterCancel(acSelContext.state.rootNode);
  };

  const handleSelectionBoxDrop = (dropItems, dropItemType) => {
    if (dropItemType === AC_GRID.AC_GRID_1) {
      const gridData = dropItems.gridarray.filter(item => item.id);
      const itemsToRemove = dropItems.selectedNodes.map(item => item.id);

      insertNodes(
        dropItems.selectedNodes.map(item =>
          checkAndAddFunctionInAutocodeNode(item.dataSmartSearch.autocodenode)
        ),
        '0',
        -1
      );

      dispatch(
        updateSampleWeighted(
          gridData.filter(({ id }) => !itemsToRemove.includes(id)),
          dropItems.gridCategory
        )
      );
    }
  };

  const handleDictionaryDrop = (dropItems, dropItemType) => {
    let datapoints = [],
      selectedAns = [];
    switch (dropItemType) {
      case AC_GRID.AC_TEMPLATE_SINGLE_LIST:
        datapoints = getDatapointsForSingleList(
          dropItems.selectedNodes,
          selectedNodeAnswers
        );
        // insert into selection box
        insertLeafNode(datapoints, AC_ROOT_NODE_ID, -1);
        break;
      case AC_GRID.AC_TEMPLATE_1_CATEGORY:
        datapoints = getDatapointsForTemplate1Category(
          dropItems.selectedNodes,
          selectedNodeAnswers,
          dropItems.userOptions,
          dropItems.selectedUserOption,
          dropItems.totalUsersItem
        );
        // insert into selection box
        insertLeafNode(datapoints, AC_ROOT_NODE_ID, -1);
        break;
      case AC_GRID.AC_TEMPLATE_1_BRAND_TYPE_KIND_FORM:
        datapoints = getDatapointsForTemplate1BrandTypeKindForm(
          dropItems.selectedNodes,
          selectedNodeAnswers,
          dropItems.userOptions,
          dropItems.selectedUserOption,
          dropItems.onePlusSelected,
          dropItems.onePlusValue
        );
        // insert into selection box
        insertLeafNode(datapoints, AC_ROOT_NODE_ID, -1);
        break;
      case AC_GRID.AC_TEMPLATE_4:
        datapoints = getDatapointsForTemplate4(
          dropItems.selectedNodes,
          selectedNodeAnswers,
          dropItems.userOptions,
          dropItems.selectedUserOption
        );
        // insert into selection box
        insertLeafNode(datapoints, AC_ROOT_NODE_ID, -1);
        break;
      case AC_GRID.AC_TEMPLATE_2:
        selectedAns = getDatapointsForTemplate278(
          dropItems.selectedList1,
          dropItems.selectedList2,
          selectedNodeAnswers
        );
        // sending data on the basis of OR
        // insert into selection box
        selectedAns.forEach(res => {
          if (dropItems.or) {
            insertOperatorNode(
              res,
              AC_OPERATORS.type.or,
              AC_ROOT_NODE_ID,
              true,
              -1
            );
          } else {
            insertLeafNode(res, AC_ROOT_NODE_ID, -1);
          }
        });
        break;
      case AC_GRID.AC_TEMPLATE_7:
        selectedAns = getDatapointsForTemplate278(
          dropItems.selectedList1,
          dropItems.selectedList2,
          selectedNodeAnswers
        );
        // sending data on the basis of OR
        selectedAns.forEach(res => {
          if (dropItems.or) {
            insertOperatorNode(
              res,
              AC_OPERATORS.type.or,
              AC_ROOT_NODE_ID,
              true,
              -1
            );
          } else {
            insertLeafNode(res, AC_ROOT_NODE_ID, -1);
          }
        });
        break;
      case AC_GRID.AC_TEMPLATE_8:
        selectedAns = getDatapointsForTemplate278(
          dropItems.selectedList1,
          dropItems.selectedList2,
          selectedNodeAnswers
        );
        // sending data on the basis of OR
        selectedAns.forEach(res => {
          const checkNetAny = res.filter(
            r => _.upperCase(r.keyword.slice(0, 3)) === 'XNA'
          );
          if (dropItems.or) {
            // if or then check for netany
            if (checkNetAny.length > 1) {
              insertOperatorNetAnyNode('net any', res, AC_ROOT_NODE_ID, -1, {
                operator: AC_OPERATORS.type.or,
              });
            } else {
              insertOperatorNode(
                res,
                AC_OPERATORS.type.or,
                AC_ROOT_NODE_ID,
                true,
                -1
              );
            }
          } else if (checkNetAny.length > 0 && !dropItems.or) {
            // if net any and single node then NETANY ( DATA )
            insertNetanyLeafNode(
              'net any',
              false,
              false,
              res,
              1,
              AC_ROOT_NODE_ID,
              -1
            );
          } else {
            insertLeafNode(res, AC_ROOT_NODE_ID, -1);
          }
        });
        break;
      default:
        console.log('default');
    }
  };

  const submitCodingBox = () => {
    document.getElementById('ac-codingbox-sample').innerHTML = '';
    document.getElementById('ac-codingbox-weighted').innerHTML = '';
    const expression = document.getElementById('ac-coding-box').innerHTML;
    const whitespace = /\s+/;

    const contentExtractor = document.createElement('div');
    contentExtractor.innerHTML = expression;
    const extractedContents = (
      contentExtractor.textContent || contentExtractor.innerText
    )
      .replace(/\(/g, ' ( ')
      .replace(/\)/g, ' ) ')
      .replace(/,/g, ' , ')
      .split(whitespace);

    if (extractedContents.length > 0) {
      let keyword = '';
      extractedContents.forEach(n => {
        keyword += ` ${n}`;
      });
      const expressionList = [];
      expressionList.push(keyword.trim());
      getSampleWeighted(
        uid,
        activeAccountId,
        moduleStudy.pn,
        selectedWeightType.wt,
        selectedWeightType.dv,
        expressionList
      ).then(response => {
        if (response && response.length > 0 && response[0] !== null) {
          document.getElementById('ac-codingbox-sample').innerHTML =
            response[0].intab;
          document.getElementById('ac-codingbox-weighted').innerHTML =
            response[0].weighted;
        }
      });
    }
  };

  const addDETargets = async () => {
    const uniqueId = _createTargetUniqueID(
      acSelContext.state.rootNode.children[0],
      acSelContext.state.partsToShow,
      moduleStudy.pn,
      selectedWeightType.wn
    );
    const duplicateData = acSelContext.deBuildTargets.filter(
      item => item.ui.toLowerCase() === uniqueId.toLowerCase()
    );
    if (duplicateData.length > 0) {
      dispatch(moduleAction.updateErrorSelectionBox(true));
    } else {
      const sampleWeightedParams = {
        accountId: activeAccountId,
        productNo: moduleStudy.pn,
        expressionList: [
          toDefString(
            acSelContext.state.rootNode.children[0],
            acSelContext.state.partsToShow
          ),
        ],
        divisor: selectedWeightType.dv,
        weightType: selectedWeightType.wt,
        uid,
      };
      if (!acSelContext.addTargetAPIFlag) {
        dispatch(moduleAction.setAddTargetFlag(true));
        const validateTargetSuccess = await dispatch(
          moduleAction.addTargets(
            sampleWeightedParams,
            moduleStudy,
            selectedWeightType,
            toLabelString(
              acSelContext.state.rootNode.children[0],
              acSelContext.state.partsToShow
            ),
            acSelContext.state.rootNode.children[0],
            uniqueId
          )
        );
        if (validateTargetSuccess) {
          removeAllNodes();
          dispatch(moduleAction.updateErrorSelectionBox(false));
        }
      }
    }
  };

  return (
    <Fragment>
      <div
        className="ac-selection-box-header-container"
        data-test="autocodeSelectionBox"
      >
        <Modal
          data-test="acCodingBoxModal"
          title="Coding Box"
          ref={node => {
            acCodingBoxModal.ref = node;
          }}
          dialogStyles={acCodingBoxModal.styles}
        >
          <div>
            <ContentEditable
              id="ac-coding-box"
              html=""
              className="ac-expression-coding-box"
              spellCheck="false"
            />
            <div>
              <span>Sample:&nbsp; </span>
              <span id="ac-codingbox-sample" />
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </span>
              <span>Weighted:&nbsp; </span>
              <span id="ac-codingbox-weighted" />
              <GenericButton
                name="Submit"
                btnStyle="save-def right"
                onBtnClick={() => {
                  submitCodingBox();
                }}
              />
            </div>
            <hr />
            <div id="ac-coding-box-table-id" className="ac-coding-box-table" />
          </div>
        </Modal>
        {!definitionTab && (
          <AutocodeLabelSelectorDropDown moduleAction={moduleAction} />
        )}

        {definitionTab && (
          <Fragment>
            <button
              type="button"
              className="row pull-left"
              onClick={() => acSelContext.state.setTabsIndex(0)}
            >
              <img
                className="autocode-backimage"
                src={backButtonArrow}
                alt="arrow"
              />
              <span>Continue in Dictionary</span>
            </button>
            {showDefEditBtn && (
              <GenericButton
                name="Edit"
                btnStyle="edit-button"
                onBtnClick={handleEditClick}
                btnDisabled={editDisabled}
              />
            )}
          </Fragment>
        )}
        {showAddSaveDefinitionBtn && (
          <React.Fragment>
            {saveDefn ? (
              <span className="save-def-active">New Definition</span>
            ) : (
              !definitionTab &&
              !(editMode || createDefMode) && (
                <GenericButton
                  name="Save Definition"
                  btnStyle="save-def"
                  onBtnClick={() => {
                    setsaveDefn(true);
                    disableAdd(true);
                  }}
                  btnDisabled={numTopLevelNodes() === 0}
                />
              )
            )}
          </React.Fragment>
        )}
        {/* <GenericButton name="Edit" btnStyle="edit-def" title="Edit" /> */}
      </div>
      {!saveDefn ? (
        <Fragment>
          <AutocodeMainSelectionBox
            numTopLevelNodes={numTopLevelNodes}
            selectedNodesCount={selectedNodesCount}
            selectedOperatorCount={selectedOperatorCount}
            handleDeleteClicked={handleDeleteClicked}
            showingInDevOnly={showingInDevOnly}
            definitionTab={definitionTab}
            tempOverridelabels={tempOverridelabels}
            groupWithOn={groupWithOn}
            setGroupWithOn={setGroupWithOn}
            moduleStudy={moduleStudy}
            moveToColumns={moveToColumns}
            moveToRows={moveToRows}
            moveToBases={moveToBases}
            selectedFuncCount={selectedFuncCount}
            setCheckBlur={setCheckBlur}
            tempShowKeywords={tempShowKeywords}
            onSelectionBoxDrop={handleSelectionBoxDrop}
            onDictionaryDrop={handleDictionaryDrop}
            tempShowKeywordsInCodingBox={tempShowKeywordsInCodingBox}
            checkApplyAllOr={checkApplyAllOr}
            insertDefinitionNodes={insertDefinitionNodes}
            addDefToSelectionBox={props.addDefToSelectionBox}
          />
          {!(editMode || createDefMode) ? (
            <div className="ac-selection-box-bottom-container">
              {showCRBBtns && (
                <React.Fragment>
                  <GenericButton
                    btnStyle=""
                    name="Columns"
                    onBtnClick={moveToColumns}
                    btnDisabled={
                      acSelContext.state.rootNode.children.length === 0
                    }
                  />
                  <GenericButton
                    btnStyle=""
                    name="Rows"
                    onBtnClick={moveToRows}
                    btnDisabled={
                      acSelContext.state.rootNode.children.length === 0
                    }
                  />
                  <GenericButton
                    btnStyle=""
                    name="Base"
                    onBtnClick={moveToBases}
                    btnDisabled={
                      acSelContext.state.rootNode.children.length === 0
                    }
                  />
                </React.Fragment>
              )}
              {showTargetBtn && (
                <GenericButton
                  btnStyle=""
                  name="Targets"
                  onBtnClick={() => addDETargets()}
                  btnDisabled={
                    acSelContext.state.rootNode.children.length !== 1 ||
                    acSelContext.errorSelectionBox
                  }
                />
              )}
              {showingInDevOnly() && !acSelContext.errorSelectionBox && (
                <GenericButton
                  btnStyle=""
                  name="Labels"
                  onBtnClick={() => tempShowLabels()}
                />
              )}
              {showingInDevOnly() && !acSelContext.errorSelectionBox && (
                <GenericButton
                  btnStyle=""
                  name="NETANY"
                  onBtnClick={() => tempNetAny()}
                />
              )}
              {showingInDevOnlyKeyword() && !acSelContext.errorSelectionBox && (
                <GenericButton
                  btnStyle=""
                  name="Keywords"
                  onBtnClick={() => tempShowKeywords()}
                />
              )}
              {showingInDevOnlyKeyword() && !acSelContext.errorSelectionBox && (
                <GenericButton
                  btnStyle=""
                  name="coding"
                  onBtnClick={() => tempShowKeywordsInCodingBox()}
                />
              )}
              {showTargetBtn && acSelContext.errorSelectionBox && (
                <span className="de--selectionbox-warningmsg">
                  {DE_BUILD_DUPLICATE_NAME_ERROR}
                </span>
              )}
              {acSelContext.state.showSmplWghtDisplay &&
                acSelContext.state.rootNode.children.length === 1 &&
                singleExpressionSampleWeighted.response &&
                singleExpressionSampleWeighted.response[0] && (
                  <div className="float-right">
                    <AutocodeSampleWeightedDisplay
                      sample={singleExpressionSampleWeighted.response[0].intab}
                      weighted={
                        singleExpressionSampleWeighted.response[0].weighted
                      }
                      study={moduleStudy}
                      sampleRedLimit={acSelContext.state.sampleLimit}
                      sampleRedLimitNCS={acSelContext.state.sampleNCSLimit}
                    />
                  </div>
                )}
            </div>
          ) : (
            <div className="ac-selection-box-editDefn-bottom-container">
              <GenericButton
                btnStyle=""
                name="Cancel"
                onBtnClick={editCreateDefCancel}
              />
              <span style={{ float: 'right' }}>
                {editMode &&
                  editFolderDetails.length === 1 &&
                  numTopLevelNodes() > 1 && (
                    <div className="error-msg">
                      To save changes to the Definition, you should have only 1
                      item in the box
                    </div>
                  )}
                <GenericButton
                  btnStyle="save-btn"
                  name="Save"
                  onBtnClick={() => patchEditCreateDefs()}
                  btnDisabled={
                    (editMode &&
                      editFolderDetails.length === 1 &&
                      numTopLevelNodes() !== 1) ||
                    numTopLevelNodes() === 0
                  }
                />
              </span>
            </div>
          )}
        </Fragment>
      ) : (
        <Fragment>
          <AutocodeSaveDefnSelectionBox
            numTopLevelNodes={numTopLevelNodes}
            showingInDevOnly={showingInDevOnly}
            definitionTab={definitionTab}
            moduleStudy={moduleStudy}
            defPartsToShow={acSelContext.state.partsToShow}
            tempOverridelabels={tempOverridelabels}
            setdefinition={setdefinition}
            setGroupWithOn={setGroupWithOn}
            cancelBulkJoinSetup={cancelBulkJoinSetup}
            saveDefnActive={saveDefn}
            setCheckBlur={setCheckBlur}
          />
          <div className="ac-selection-box-saveDefn-bottom-container">
            <GenericButton
              btnStyle="cancel-btn"
              name="Cancel"
              onBtnClick={() => {
                setsaveDefn(false);
                disableAdd(false);
                setdefinition({
                  definitionId: 0,
                  folderName: '',
                });
              }}
            />
            <GenericButton
              btnStyle="save-btn"
              name="Save"
              onBtnClick={() => {
                addToDefinition();
              }}
              btnDisabled={definition.definitionId === 0}
            />
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

AutocodeSelectionBox.propTypes = {
  definitionTab: PropTypes.bool,
  disableAdd: PropTypes.func,
  moduleAction: PropTypes.shape({
    addTargets: PropTypes.func,
    updateSelectionBoxFlag: PropTypes.func,
    updateErrorSelectionBox: PropTypes.func,
    setEditTargetNode: PropTypes.func,
    setTempSelectedTargetForBuild: PropTypes.func,
  }),
  moduleStudy: PropTypes.shape({
    st: PropTypes.string,
    ss: PropTypes.string,
    pn: PropTypes.number,
  }),
  uid: PropTypes.number,
  selectedWeightType: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
  ExistingGridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  setCheckBlur: PropTypes.shape({}),
  showDefEditBtn: PropTypes.bool,
};

export default AutocodeSelectionBox;
